import React, { useEffect, useState } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import useReviewersStatistics from '../hooks/useReviewersStatistics'
import LoaderReviewersStatistics from '../components/reviewers-statistics-page/LoaderReviewersStatistics'
import ReviewersStatisticsGrid from '../components/reviewers-statistics-page/ReviewersStatisticsGrid'
import Breadcrumb from '../../core/components/UI/Breadcrumb'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export default function ReviewersStatisticsPage() {
  const { statistics, isLoading } = useReviewersStatistics()
  const [chartData, setChartData] = useState([])

  const assignColor = (index) => {
    const colors = [
      'rgba(255, 99, 132, 0.6)',
      'rgba(54, 162, 235, 0.6)',
      'rgba(255, 206, 86, 0.6)',
      'rgba(75, 192, 192, 0.6)',
      'rgba(153, 102, 255, 0.6)',
      'rgba(255, 159, 64, 0.6)',
      'rgba(100, 100, 200, 0.6)',
    ]
    return colors[index % colors.length]
  }

  useEffect(() => {
    if (!isLoading && statistics) {
      const groupedData = statistics.reduce((acc, review) => {
        const { review_question_id, question, text_ar, reviews_count } = review
        if (!acc[review_question_id]) {
          acc[review_question_id] = { question: question.text_ar, options: [] }
        }
        acc[review_question_id].options.push({
          text: text_ar,
          reviewsCount: reviews_count,
        })
        return acc
      }, {})

      const shortenText = (text, maxLength = 20) =>
        text.length > maxLength ? `${text.substring(0, maxLength)}...` : text

      setChartData(
        Object.values(groupedData).map(({ question, options }) => ({
          question,
          chartData: {
            labels: options.map((option) => shortenText(option.text)),
            datasets: [
              {
                label: 'عدد التقييمات',
                data: options.map((option) => option.reviewsCount),
                backgroundColor: options.map((_, index) => assignColor(index)),
                borderColor: options.map((_, index) =>
                  assignColor(index).replace('0.6', '1'),
                ),
                borderWidth: 1,
              },
            ],
          },
          labelsFull: options.map((option) => option.text),
          colors: options.map((_, index) => assignColor(index)),
        })),
      )
    }
  }, [isLoading, statistics])

  return (
    <>
      <Breadcrumb />
      <div className="flex w-full flex-col">
        {isLoading ? (
          <LoaderReviewersStatistics />
        ) : (
          <ReviewersStatisticsGrid chartData={chartData} />
        )}
      </div>
    </>
  )
}
